<div>
    <table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
        <thead>
            <tr>
                <th class="header-cell" style="padding-left: 24px !important;">Id, Actual Version</th>
                <th class="header-cell right-text">Group Ids</th>
                <th class="header-cell right-text">Buildings</th>
                <th class="header-cell right-text">Allowed Uses</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let statistic of solrGroupIdsStatistic" [ngTemplateOutlet]="zcvStatistic"
                [ngTemplateOutletContext]="{ statistic: statistic }"></ng-container>
        </tbody>
    </table>
</div>

<ng-template #zcvStatistic let-statistic="statistic">
    <tr class="lower-height-row">
        <td class="title-cell">{{statistic.zcvId}}, {{statistic.actualVersion || 'No
            Data'}}{{statistic.isLatest?'*':''}}</td>
        <td>{{ statistic.addGroupIdsProcessed | number }}</td>
        <td>{{ statistic.buildingsProcessed | number }}</td>
        <td>{{ statistic.usesHashesAdded | number }}</td>
    </tr>
</ng-template>